module.exports = __webpack_public_path__ + "fonts/Timelapse.bf97ba53.woff";